module.exports = __webpack_public_path__ + "img/applicationSettings.f8e2fdb3.svg";